import { useAnalytics } from "@accurx/analytics";
import { Ds } from "@accurx/design";
import { PatientExternalId } from "@accurx/native";
import { ContactDetail } from "domains/message-component/reducer.types";

import { CustomContactDetailForm } from "./CustomContactDetailForm";

type CustomContactFormContentProps = {
    contactDetails: ContactDetail[];
    patientExternalIds: PatientExternalId[];
    setIsOpen: (open: boolean) => void;
    setShowCustomContactDetailsForm: (showForm: boolean) => void;
    customInputValue: string;
    setCustomInputValue: (inputValue: string) => void;
    shouldDisableEmail: boolean;
};

export const CustomContactFormContent = ({
    contactDetails,
    patientExternalIds,
    setIsOpen,
    setShowCustomContactDetailsForm,
    customInputValue,
    setCustomInputValue,
    shouldDisableEmail,
}: CustomContactFormContentProps) => {
    const track = useAnalytics();

    return (
        <>
            <Ds.Popover.Header>
                <Ds.Text
                    as="h2"
                    size="large"
                    id="custom-contact-detail-form"
                    weight="bold"
                >
                    Add new mobile or email
                </Ds.Text>
            </Ds.Popover.Header>

            <Ds.Popover.Body>
                <Ds.Box>
                    <Ds.Flex flexDirection="column" gap="2">
                        <CustomContactDetailForm
                            patientExternalIds={patientExternalIds}
                            formLabelledById="custom-contact-detail-form"
                            formSubmitButtonId="contact-detail-custom-form"
                            onContactDetailAdded={(contactDetail) => {
                                setIsOpen(false);
                                setShowCustomContactDetailsForm(false);
                                track(
                                    "PatientMessageContactOptionConfirm Button Click",
                                    {
                                        contactType: contactDetail.method,
                                        contactOrigin: contactDetail.origin,
                                    },
                                );
                            }}
                            canSubmitEmail={!shouldDisableEmail}
                            inputValue={customInputValue}
                            setInputValue={setCustomInputValue}
                        />
                    </Ds.Flex>
                </Ds.Box>
            </Ds.Popover.Body>

            <Ds.Popover.Footer>
                {contactDetails.length > 0 && (
                    <Ds.Button
                        appearance="tertiary"
                        size="small"
                        onClick={() => setShowCustomContactDetailsForm(false)}
                        aria-label="Go back"
                    >
                        <Ds.Icon name="ArrowTail" rotate="270" size="small" />
                        Back
                    </Ds.Button>
                )}

                <Ds.Form.Submit
                    type="submit"
                    size="small"
                    form="contact-detail-custom-form"
                >
                    Add
                </Ds.Form.Submit>
            </Ds.Popover.Footer>
        </>
    );
};
